export default __webpack_public_path__ + "static/media/noimage2.10d6ae03.jpg";